// extracted by mini-css-extract-plugin
module.exports = {"container":"_1fQCUXwG0TLjZtezT3g9GV","title":"_2M3M74hUC0JuVtCghIipuM","icon":"_3tKMsz-YWsLSe-n-piFz7o","subtitle":"_1QNbUSjkeNKYQ78-PAo5U0"};